module.exports = __webpack_public_path__ + "static/media/dga.29716fb4.png";